import { composeMoney } from '@pbk/utils';
export const composeMoneyWithoutFractionDigitsAndCurrency = (amount) => {
    return composeMoney({
        money: { amount },
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
};
